import { type HTMLAttributes } from "react"
import { twMerge } from "tailwind-merge"

const TransparentBackgroundWrapper = ({
  className,
  style,
  ...props
}: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={twMerge("rounded-xl bg-neutral-500/5", className)}
      style={{
        backgroundImage: `repeating-conic-gradient(hsl(var(--fg-default) / 2%) 0% 25%, transparent 0% 50%)`,
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0",
        ...style,
      }}
      {...props}
    />
  )
}

export default TransparentBackgroundWrapper
